import React from "react";
import { Grid, TextField, GridProps, TextFieldProps } from "@mui/material";
import { Typography } from "@financeable-com-au/financeable-ui";

interface FormInputFieldProps extends Omit<TextFieldProps, "name" | "value" | "onChange" | "onBlur" | "error"> {
  fieldName: string;
  label: string;
  value?: string | number | null;
  error?: boolean | string; // MUI TextField expects boolean for error prop
  helperText?: string | boolean; // Add helperText for error messages
  disabled?: boolean;
  onChange: (value: string, fieldName: string) => void;
  onBlur: (fieldName: string, value: string) => void;
  maxLength?: number;
  gridProps?: GridProps;
  variant?: "outlined" | "filled" | "standard";
}

const FormInputField: React.FC<FormInputFieldProps> = ({
  fieldName,
  label,
  value,
  error,
  disabled = false,
  onChange,
  onBlur,
  maxLength = 50,
  gridProps = { md: 4, sm: 12, xs: 12 },
  variant = "outlined",
  ...rest
}) => {
  return (
    <Grid item {...gridProps}>
      {/* <Typography level="body-sm">
        {label}
      </Typography> */}

      <TextField
        fullWidth
        id={`${fieldName}-input`}
        name={fieldName}
        label={label}
        disabled={disabled}
        value={value ?? ""}
        error={Boolean(error)}
        helperText={error ?? undefined}
        onChange={(e) => onChange(e.target.value, fieldName)}
        onBlur={(e) => onBlur(fieldName, e.target.value)}
        variant={variant}
        size="small"
        inputProps={{ maxLength, ...(rest.inputProps || {}) }}
        {...rest} // spread all other props into TextField
      />
    </Grid>
  );
};

export default FormInputField;
